import React from "react";

function Offers() {
  return (
    <section id="offers" className="container py-5">
      <div className="row ">
        <div className=" col-12 col-md-4 p-2 px-3" data-aos="fade-up">
          <div>
            <h2>Best Loan and Insurance Offers</h2>
            <p className="mt-4">
              At Bsecure Advisory Services, we provide comprehensive loan
              assistance as direct selling agents for over 100 banks and NBFCs.
              We offer personal loans, home loans, business loans, auto loans,
              education loans, and loans against property. Our goal is to ensure
              you receive the best rates and benefits, making your loan journey
              smooth and hassle-free. Trust us to help you achieve your
              financial goals with ease.
            </p>
           
          </div>
        </div>
        <div className=" col-12 col-md-4 p-2 px-3" data-aos="fade-up"  data-aos-delay="300" >
          <div>
            <h2>Debt Management Solutions</h2>
            <p className="mt-4">
              Managing debt can be challenging, but Bsecure is here to help. Our
              debt management services assist you in consolidating,
              restructuring, and repaying your debts efficiently. We work with
              you to develop a personalized debt management plan that fits your
              financial situation and goals. Let us guide you through debt
              management with expertise and care, ensuring financial stability
              and peace of mind.
            </p>
           
          </div>
        </div>
        <div className=" col-12 col-md-4 p-2 px-3"  data-aos="fade-up"  data-aos-delay="600" >
          <div>
            <h2>Expert Insurance Advisory Solutions</h2>
            <p className="mt-4">
              Navigating insurance can be overwhelming, but Bsecure makes it
              simple and effective. Our advisory services cover life, health,
              property, and business insurance. We offer personalized solutions
              to meet your unique needs and financial goals. Whether you need
              term life insurance, health plans, homeowners insurance, or
              business insurance, we provide comprehensive coverage tailored to
              your requirements. Let us safeguard your future with confidence.
            </p>
           
          </div>
        </div>
      </div>
    </section>
  );
}

export default Offers;
